<bp-svg-icon
	*ngIf="value | bpIsBoolean; else countTpl"
	class="inline-flex"
	name="check-{{ value ? 'yes' : 'no' }}"
></bp-svg-icon>

<ng-template #countTpl>
	<span [class.count]="value | bpIsNumber">{{ value }}</span>
</ng-template>
